// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eb1b8a97","337":"ae68dbb7","453":"cfd59cba","667":"4bc45f39"}[chunkId] + ".chunk.js";
};